import React from "react";
import { Image } from "react-native";
import { useNetworkStore } from "../store/networkStore";
import Toast, { ToastVariant } from "./Toast";
import { TOAST_DURATION } from "./toastDurations";
import { colors } from "../styles";

// eslint-disable-next-line @typescript-eslint/no-require-imports
const wifiOffIcon = require("../assets/icons/wifi-off.png");

interface OfflineToastProps {
  variant?: ToastVariant;
}

const ICON_TINT: Record<ToastVariant, string> = {
  light: colors.toastLightText,
  dark: colors.toastDarkTitle,
  purple: colors.white,
};

/**
 * Drop-in offline notification. Screens that want it just render:
 *   <OfflineToast variant="dark" />
 * All logic (visibility, message) is handled internally.
 */
export default function OfflineToast({ variant = "dark" }: OfflineToastProps) {
  const { isOffline, reason } = useNetworkStore();

  return (
    <Toast
      title="Offline"
      body={reason === "device"
        ? "Check your connection or ask a grownup for help."
        : "Having trouble connecting. Trying again..."}
      icon={<Image source={wifiOffIcon} style={{ width: 24, height: 24, tintColor: ICON_TINT[variant] }} resizeMode="contain" />}
      variant={variant}
      visible={isOffline}
      duration={TOAST_DURATION.PERSISTENT}
    />
  );
}
